import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ISharedSitePermitFieldsFragment = {
  projectToId?: any | null
  projectFromId?: any | null
  id?: any | null
  permitId?: any | null
  isAllDay?: boolean | null
  locationName?: string | null
  locationUrl?: string | null
  companyName?: string | null
  summary?: string | null
  startDate?: any | null
  endDate?: any | null
  status?: Types.SitePermitStatus | null
  tenantName?: string | null
  projectUrl?: string | null
  responsible?: {
    firstName?: string | null
    lastName?: string | null
    phoneNumber?: string | null
    email?: string | null
  } | null
}

export type IGetSharedSitePermitsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetSharedSitePermitsQuery = {
  getSharedSitePermitsByProjectToId?: Array<{
    projectToId?: any | null
    projectFromId?: any | null
    id?: any | null
    permitId?: any | null
    isAllDay?: boolean | null
    locationName?: string | null
    locationUrl?: string | null
    companyName?: string | null
    summary?: string | null
    startDate?: any | null
    endDate?: any | null
    status?: Types.SitePermitStatus | null
    tenantName?: string | null
    projectUrl?: string | null
    responsible?: {
      firstName?: string | null
      lastName?: string | null
      phoneNumber?: string | null
      email?: string | null
    } | null
  } | null> | null
}

export type IListenToSharedSitePermitsSubscriptionVariables = Types.Exact<{
  projectToId?: Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IListenToSharedSitePermitsSubscription = {
  sharedSitePermit?: {
    id?: any | null
    item?: {
      projectToId?: any | null
      projectFromId?: any | null
      id?: any | null
      permitId?: any | null
      isAllDay?: boolean | null
      locationName?: string | null
      locationUrl?: string | null
      companyName?: string | null
      summary?: string | null
      startDate?: any | null
      endDate?: any | null
      status?: Types.SitePermitStatus | null
      tenantName?: string | null
      projectUrl?: string | null
      responsible?: {
        firstName?: string | null
        lastName?: string | null
        phoneNumber?: string | null
        email?: string | null
      } | null
    } | null
  } | null
}

export const SharedSitePermitFieldsFragmentDoc = gql`
  fragment SharedSitePermitFields on SharedSitePermit {
    projectToId
    projectFromId
    id
    permitId
    isAllDay
    locationName
    locationUrl
    companyName
    summary
    startDate
    endDate
    status
    tenantName
    projectUrl
    responsible {
      firstName
      lastName
      phoneNumber
      email
    }
  }
`
export const GetSharedSitePermitsDocument = gql`
  query GetSharedSitePermits($projectId: ObjectId!) {
    getSharedSitePermitsByProjectToId(projectId: $projectId) {
      ...SharedSitePermitFields
    }
  }
  ${SharedSitePermitFieldsFragmentDoc}
`

/**
 * __useGetSharedSitePermitsQuery__
 *
 * To run a query within a React component, call `useGetSharedSitePermitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedSitePermitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedSitePermitsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSharedSitePermitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetSharedSitePermitsQuery,
    IGetSharedSitePermitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSharedSitePermitsQuery,
    IGetSharedSitePermitsQueryVariables
  >(GetSharedSitePermitsDocument, options)
}
export function useGetSharedSitePermitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSharedSitePermitsQuery,
    IGetSharedSitePermitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSharedSitePermitsQuery,
    IGetSharedSitePermitsQueryVariables
  >(GetSharedSitePermitsDocument, options)
}
export type GetSharedSitePermitsQueryHookResult = ReturnType<
  typeof useGetSharedSitePermitsQuery
>
export type GetSharedSitePermitsLazyQueryHookResult = ReturnType<
  typeof useGetSharedSitePermitsLazyQuery
>
export type GetSharedSitePermitsQueryResult = Apollo.QueryResult<
  IGetSharedSitePermitsQuery,
  IGetSharedSitePermitsQueryVariables
>
export const ListenToSharedSitePermitsDocument = gql`
  subscription listenToSharedSitePermits($projectToId: ObjectId) {
    sharedSitePermit(projectToId: $projectToId) {
      id
      item {
        ...SharedSitePermitFields
      }
    }
  }
  ${SharedSitePermitFieldsFragmentDoc}
`

/**
 * __useListenToSharedSitePermitsSubscription__
 *
 * To run a query within a React component, call `useListenToSharedSitePermitsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToSharedSitePermitsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToSharedSitePermitsSubscription({
 *   variables: {
 *      projectToId: // value for 'projectToId'
 *   },
 * });
 */
export function useListenToSharedSitePermitsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    IListenToSharedSitePermitsSubscription,
    IListenToSharedSitePermitsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToSharedSitePermitsSubscription,
    IListenToSharedSitePermitsSubscriptionVariables
  >(ListenToSharedSitePermitsDocument, options)
}
export type ListenToSharedSitePermitsSubscriptionHookResult = ReturnType<
  typeof useListenToSharedSitePermitsSubscription
>
export type ListenToSharedSitePermitsSubscriptionResult =
  Apollo.SubscriptionResult<IListenToSharedSitePermitsSubscription>
